const suggestionData = [
    '“Melbourne craft beer”',
    '“Wine that goes with lamb”',
    '“Fruity white wine”',
    '“Red wine by [BRAND NAME]”',
    '“A chardonnay from 2012”',
    '“A Tasmanian Pinot Noir”',
    '“A French white wine”',
    '“A crisp Pinot Grigio”',
    '“A mineral Riesling”',
    '“A dry rosé”',
    '“A dry 2019 Shiraz from Barossa”',
    '“A New Zealand wine that goes with chicken”',
    '“A crisp white from Adelaide Hills”',
    '“Vegan friendly sparkling wine from Victoria”',
    '“Organic Italian red wine”',
    '“Gluten free sweet rosé”'
];
const staticSuggestionText = 'Now you can search for exactly what you want: Try something like:';

let setTopTimeout;

class SearchAiContentController {
    constructor($rootScope, SearchService, jQuery) {
        this.$onInit = function() {
            this.searchService = SearchService;
            this.staticSuggestionText = staticSuggestionText;
            this.aiSuggestionList = suggestionData;
            this.suggestionText = '';
            this.numberOfSuggestions = [1, 2];
            this.getSuggestionList(this.aiSuggestionList);
            this.setLongtailBannerTopPos();
            this.setAutocompletePanelTopPos();
            $rootScope.$on('updateAutoSuggestTopPos', (event, data) => {
                if (data) {
                    this.setAutocompletePanelTopPos();
                } else {
                    this.resetAutocompletePanelTopPos();
                }
            });
            $rootScope.$on('$destroy', function () {
                clearTimeout(setTopTimeout);
            });
            $rootScope.$on('window:resize', () => {
                this.setLongtailBannerTopPos();
                this.setAutocompletePanelTopPos();
            });
            jQuery('html').on('click', (event) => {
                const searchSuggestionAlertBox = document.getElementsByClassName('bws-search-bar');
                if (this.searchService.getAIBoxVisibility()) {
                    const isClickInsideElement = searchSuggestionAlertBox[0].contains(event.target);
                    if (!isClickInsideElement) {
                        this.searchService.setAIBoxVisibility(false);
                    }
                }
            });
        };
    }

    getSuggestionList(data) {
        const iterator$ = this.selectUniqueSuggestions(data).values();
        this.suggestionText += `${iterator$.next().value}, ${iterator$.next().value}`;
    }

    selectUniqueSuggestions(data) {
        const suggestionSet = new Set();
        this.numberOfSuggestions.forEach(() => {
            const randomIndex = Math.floor(Math.random() * data.length);
            const suggestion = (!suggestionSet.has(data[randomIndex])) ? data[randomIndex] :
                (data[randomIndex - 1] !== undefined) ? data[randomIndex - 1] :
                    (data[randomIndex + 1] !== undefined) ? data[randomIndex + 1] : data[0];
            suggestionSet.add(suggestion);
        });
        return suggestionSet;
    }

    stopEventBubbling(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    closeAISuggestionBox(event) {
        this.stopEventBubbling(event);
        this.resetAutocompletePanelTopPos();
        this.searchService.setAIBoxVisibility(false);
        this.searchService.setAIBoxInActive();
    }

    setAutocompletePanelTopPos() {
        let searchBarRect, aiBoxRect;
        const aiBoxEle = document.getElementById('cx-ai-box');
        const searchBarEle = document.getElementById('bws-search-bar');
        if (searchBarEle) { searchBarRect = searchBarEle.getBoundingClientRect(); }
        if (aiBoxEle) {
            aiBoxRect = aiBoxEle.getBoundingClientRect();
            setTopTimeout = setTimeout(() => {
                const newTopValue = (window.matchMedia('(min-width: 768px)').matches) ?
                    `${aiBoxRect.height + searchBarRect.height + 4}px` : `${aiBoxRect.height}px`;
                const newHeight = `calc(100vh - ${110 + aiBoxRect.height}px)`;
                const bottomPadding = (window.matchMedia('(max-width: 767px)').matches) ? '0px' : `${aiBoxRect.height}px`;
                this.modifyAutocompleteListStyle(newTopValue, newHeight, bottomPadding);
            });
        }
    }

    resetAutocompletePanelTopPos() {
        const resetTopValue = (window.matchMedia('(min-width: 768px)').matches) ? '64px' : '0px';
        const newHeight = `calc(100vh - 110px)`;
        this.modifyAutocompleteListStyle(resetTopValue, newHeight, '0px');
    }

    modifyAutocompleteListStyle(top, height, bottomPadding) {
        const autocompletePanel = document.getElementsByClassName('bws-search-bar_list_items');
        const autocompleteList = document.getElementsByClassName('bws-search-bar_searchBarAutocomplete');
        if (autocompletePanel.length > 0) {
            Array.from(autocompletePanel).forEach(ele => {
                ele.style.setProperty('top', top, 'important');
                ele.style.setProperty('max-height', height, 'important');
            });
            if (autocompleteList.length > 0) {
                Array.from(autocompleteList).forEach(ele => {
                    ele.style.setProperty('padding-bottom', bottomPadding, 'important');
                });
            }
        }
    }

    setLongtailBannerTopPos() {
        let searchBarRect;
        const aiBoxEle = document.getElementById('cx-ai-box');
        const searchBarEle = document.getElementById('bws-search-bar');
        if (searchBarEle) { searchBarRect = searchBarEle.getBoundingClientRect(); }
        if (aiBoxEle) {
            const topValue = (searchBarRect.top === searchBarRect.height) ? (searchBarRect.top + 2) :
            (searchBarRect.height + 4).toFixed();
            setTopTimeout = setTimeout(() => {
                aiBoxEle.style.setProperty('top', `${topValue}px`, 'important');
            });
        }
    }
}

module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'vm',
        controller: ['$rootScope', 'SearchService', 'jQuery', '$window', SearchAiContentController],
        bindToController: {
        },
        scope: {
        },
        template: require('./search-ai-content-template.html')
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-ai-content-directive.js
 **/